import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=e30a2850&scoped=true&lang=pug&"
import script from "./simple.vue?vue&type=script&lang=js&"
export * from "./simple.vue?vue&type=script&lang=js&"
import style0 from "./simple.vue?vue&type=style&index=0&id=e30a2850&prod&lang=scss&"
import style1 from "./simple.vue?vue&type=style&index=1&id=e30a2850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30a2850",
  null
  
)

export default component.exports